import { render, staticRenderFns } from "./RecommendedStudent.vue?vue&type=template&id=5d076fca&scoped=true"
import script from "./RecommendedStudent.vue?vue&type=script&lang=js"
export * from "./RecommendedStudent.vue?vue&type=script&lang=js"
import style0 from "./RecommendedStudent.vue?vue&type=style&index=0&id=5d076fca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d076fca",
  null
  
)

export default component.exports